import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted } from "vue";
import * as echarts from "echarts";

interface Props {
  value: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GaugeRAOS',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

const chartRef = ref<HTMLDivElement | null>(null);
let chart: echarts.ECharts | null = null;

onMounted(() => {
  if (chartRef.value) {
    chart = echarts.init(chartRef.value);
    setOption();
  }
});

// Actualizar cuando cambie value
watch(() => props.value, () => setOption());

function setOption() {
  if (!chart) return;
  chart.setOption({
    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: 100,
        axisLine: {
          lineStyle: {
            width: 10,
            color: [
              [0.05, "grey"],     // 0–0.5
              [0.7, "red"],     // 0.05–70
              [0.85, "yellow"], // 70–85
              [1, "green"],     // 85–100
            ],
          },
        },
        pointer: {
          show: true,
          width: 3,
          length: "70%",
        },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        detail: { show: false },
        data: [{ value: props.value }],
      },
    ],
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartRef",
    ref: chartRef,
    style: {"width":"120px","height":"50px"}
  }, null, 512))
}
}

})